import * as CampaignsSettingsActions from './actions'
import * as SnackbarActions from '../../snackbar/actions'
import {store} from "../../../reducers";
import {app} from "../../../config/constants"
import {clones} from "../../../reducers/settings/clones"
import {settingsSaved} from "./actions"


export const updateSettingsValue = (event) => {
	const target = event.target;
	const value = target.type === 'checkbox' ? target.checked : target.value;
	const name = target.name;

	const settingsProperty = target.dataset.settingsProperty;

	store.dispatch(CampaignsSettingsActions.updateTypeValue(name, value, target.getAttribute('fieldkey'), settingsProperty));
};

export const addSettingsField = (settingsProperty) => {
	// add a new item to firebase, then pass it to redux
	const SettingsRef = app.database().ref('/cams/settings/campaigns/' + settingsProperty);

	SettingsRef.push(clones[settingsProperty][0]);
};

export const removeSettingsField = (settingsProperty, nodeId) => {
	const SettingsRef = app.database().ref('/cams/settings/campaigns/' + settingsProperty);

	SettingsRef.child(nodeId).remove();
};

export const loadCampaignSettings = () => {
	store.dispatch( CampaignsSettingsActions.resetSettings() );

	['types', 'subjects', 'departments'].map((kind, key) => {
		const ref = app.database().ref('/cams/settings/campaigns/' + kind);

		ref.on('child_added', (childSnap) => {
			store.dispatch(CampaignsSettingsActions.addSettingsField(kind, childSnap));
		});

		ref.on('child_changed', (childSnap) => {
			store.dispatch(CampaignsSettingsActions.changeSettingsField(kind, childSnap));
		});

		ref.on('child_removed', (childSnap) => {
			store.dispatch(CampaignsSettingsActions.removeSettingsField(kind, childSnap));
		});
	});
};

export const loadCampaigns = () => {
	let allCampaigns = [];

	new Promise( resolve => {
		let j = 0;
		app.database().ref('/cams/campaigns')
			.orderByChild( 'title' )
			.once('value', (campaignSnap) => {

				campaignSnap.forEach( campaign => {
					allCampaigns.push({
						title: campaign.val().title,
						key: campaign.key,
						archived: (
							undefined !== campaign.val().archived && true === campaign.val().archived
						)
					})

					if ( ++j === campaignSnap.numChildren() ) {
						resolve(allCampaigns)
					}
				});
			});
	}).then( campaigns => {
		store.dispatch( CampaignsSettingsActions.addCampaigns( campaigns ) );

		app.database().ref('/cams/campaigns')
			.orderByChild( 'title' )
			.on('child_added', (campaignSnap) => {
				const loaded = campaigns.find( campaign => campaignSnap.key === campaign.key );

				if ( undefined === loaded ) {
					store.dispatch( CampaignsSettingsActions.addCampaign( campaignSnap ) );
				}
			});

	})
};

export const saveSettings = () => {
	const state = store.getState();

	state.campaignSettings.subjects.map((setting, key) => {
		app.database().ref('/cams/settings/campaigns/subjects/' + setting.key).set({
			name: setting.name,
		});
	});

	state.campaignSettings.types.map((setting, key) => {
		app.database().ref('/cams/settings/campaigns/types/' + setting.key).set({
			name: setting.name,
		});
	});

	state.campaignSettings.departments.map((setting, key) => {
		app.database().ref('/cams/settings/campaigns/departments/' + setting.key).set({
			name: setting.name,
		});
	});

	store.dispatch(settingsSaved());

	setTimeout( () => {
		store.dispatch( SnackbarActions.close() );
	}, 4000 );


};


// WEBPACK FOOTER //
// ./src/api/settings/campaigns/index.js